import { useState } from "react";

const HoverTooltip = ({ info, children }) => {
    const [isHovered, setIsHovered] = useState(false);

    return (
        <div 
            style={{ position: "relative", display: "inline-block" }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            {children}
            {isHovered && (
                <div 
                    style={{
                        position: "absolute",
                        left: "50%",
                        transform: "translateX(-50%)",
                        marginTop: "8px",
                        width: "18rem",
                        padding: "8px",
                        backgroundColor: "#1a202c",
                        color: "#fff",
                        fontSize: "0.875rem",
                        borderRadius: "0.5rem",
                        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                        whiteSpace: "nowrap",
                        textAlign: "center",
                        height: "fit-content",
                        lineBreak: "auto",
                        wordWrap: "break-word",
                        overflowWrap: "break-word",
                        height:'auto'
                    }}
                >
                    {info}
                </div>
            )}
        </div>
    );
};

export default HoverTooltip;
